import AuthService from "../services/AuthService";
import SettingService from "../services/SettingService";
import axios from "axios";
import Cookies from 'js-cookie';
import { clearClientSession, redirectToLoginPage, isAuthRedirectInFlight, } from "../../helper/sessionRedirect";
import { navigateAfterLogin, clearHubSunsetStorage } from "../../helper/hubSunset";
export default {
    state: {
        /** Chỉ bật sau login/bootstrap thành công — tránh token cũ trong localStorage. */
        isAuthenticated: false,
        user: {},
        userPosition: {},
        userTeam: {},
        userTitle: {},
        modalIsOpen: false,
        dictionaryTagSetting: {},
        /** Payload từ API login khi AGENCY_LEGACY_LAUNCH_NOTICE_ENABLED + host legacy */
        chatLaunchNotice: null,
    },
    getters: {
        isAuthenticated(state) {
            const hasToken = typeof localStorage !== "undefined" &&
                localStorage.getItem("access_token") !== null &&
                localStorage.getItem("access_token") !== "";
            return hasToken && state.isAuthenticated;
        },
        user(state) {
            return state.user;
        },
        /** Quyền truy cập công ty của user hiện tại (full | agency | none | ""). */
        companyAccess(state) {
            return String(state.user?.company_access || "");
        },
        /** Có toàn quyền nội bộ (HQ). */
        isFullCompanyAccess(state) {
            return String(state.user?.company_access || "") === "full";
        },
        /** IT / support — chat_access=public. */
        isChatAccessPublic(state) {
            return String(state.user?.chat_access || "") === "public";
        },
        /** Cờ super admin (role=super_admin). */
        isSuperAdmin(state) {
            return !!state.user?.is_super_admin;
        },
        /** Mọi menu nâng cao (Thư viện, Sơ đồ tổ chức, Quản lý nội bộ, WIKI). */
        canAccessAdvancedWorkplace(_state, getters) {
            return !!(getters.isFullCompanyAccess || getters.isSuperAdmin);
        },
    },
    mutations: {
        isAuthenticated(state, data) {
            state.isAuthenticated = data.isAuthenticated;
        },
        updateUser(state, data) {
            state.user = data;
        },
        updateUserPosition(state, data) {
            state.userPosition = data;
        },
        updateUserTeam(state, data) {
            state.userTeam = data;
        },
        updateUserTitle(state, data) {
            state.userTitle = data;
        },
        updateModalIsOpen(state, data) {
            state.modalIsOpen = data;
        },
        updateDictionarySetting(state, data) {
            state.dictionaryTagSetting = data;
        },
        setChatLaunchNotice(state, data) {
            state.chatLaunchNotice = data;
        },
    },
    actions: {
        commitSessionFromLoginData({ commit, dispatch }, res) {
            if (!res || !res.data || !res.status) {
                return false;
            }
            const token = res.data.access_token;
            const userId = res.data.user.id;
            const launchNotice = res.data.chat_launch_notice;
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            localStorage.setItem("access_token", token);
            localStorage.setItem("user_id", userId);
            Cookies.set('access_token', token);
            Cookies.set('user_id', userId);
            commit("isAuthenticated", { isAuthenticated: true });
            commit("updateUser", res.data.user);
            commit("updateUserPosition", res.data.position);
            commit("updateUserTeam", res.data.team);
            commit("updateUserTitle", res.data.title);
            if (launchNotice && launchNotice.show) {
                commit("setChatLaunchNotice", launchNotice);
                try {
                    sessionStorage.setItem("chat_launch_notice", JSON.stringify(launchNotice));
                }
                catch (e) {
                    /* ignore quota */
                }
                navigateAfterLogin(true);
                return true;
            }
            commit("setChatLaunchNotice", null);
            clearHubSunsetStorage();
            dispatch("getPost");
            dispatch("getSocialSettings");
            dispatch("refreshPostTotalPage");
            dispatch("refreshPreviousDetail");
            dispatch("getGroups");
            dispatch("chat/getChatGroup");
            if ([1, 2, 119, 141, 845, 921, 920, 869].includes(res.data.user.id)) {
                dispatch("getPositionList");
                dispatch("getDepartmentTree");
            }
            navigateAfterLogin(false);
            dispatch("refreshNotificationSetting");
            dispatch("changePostFlag", 0);
            dispatch("connectSocketAfterLogin");
            return true;
        },
        connectSocketAfterLogin() {
            const token = localStorage.getItem("access_token");
            if (!token) {
                return;
            }
            // Dùng socket toàn cục từ main.ts — không tạo io() thứ 2 (tránh nhân đôi listener / OOM).
            const start = window.startWebsocket;
            if (typeof start === "function") {
                start(String(token).replace("%", "|"));
            }
        },
        bootstrapSso({ dispatch }) {
            return AuthService.bootstrapSsoSession().then(res => {
                if (res && res.status) {
                    dispatch("commitSessionFromLoginData", res);
                }
                return res;
            });
        },
        refreshSessionProfile({ commit, state }) {
            const token = localStorage.getItem("access_token");
            if (!token) {
                return Promise.resolve(null);
            }
            return AuthService.getSessionProfile().then((res) => {
                const profile = res && res.data ? res.data : null;
                if (!profile || !state.user || !state.user.id) {
                    return res;
                }
                const avatarUrl = (profile.avatar && (profile.avatar.url || profile.avatar)) ||
                    profile.avatar_url ||
                    null;
                const thumbnail = profile.thumbnail || (profile.avatar
                    ? {
                        small_thumb: profile.avatar.small_thumb || profile.avatar.url || null,
                        medium_thumb: profile.avatar.medium_thumb || profile.avatar.small_thumb || profile.avatar.url || null,
                        regular_thumb: profile.avatar.regular_thumb || profile.avatar.url || null,
                    }
                    : null);
                commit("updateUser", {
                    ...state.user,
                    chat_access: profile.chat_access ?? state.user.chat_access,
                    company_access: profile.company_access ?? state.user.company_access,
                    is_super_admin: profile.is_super_admin ?? state.user.is_super_admin,
                    ...(avatarUrl ? { avatar_url: avatarUrl } : {}),
                    ...(thumbnail ? { thumbnail } : {}),
                });
                return res;
            }).catch(() => null);
        },
        login({ commit, dispatch }, payload) {
            //get X-XSRF-TOKEN
            return AuthService.login(payload).then(res => {
                if (res.data && res.status) {
                    dispatch("commitSessionFromLoginData", res);
                }
                return res;
            });
        },
        logout({ commit, dispatch }, payload) {
            const token = localStorage.getItem("access_token");
            if (token) {
                AuthService.logout(payload).catch(() => undefined);
            }
            commit("setChatLaunchNotice", null);
            commit("isAuthenticated", { isAuthenticated: false });
            commit("updateUser", {});
            clearClientSession();
            import("../../helper/sso").then((m) => m.resetSsoConfigCache()).catch(() => undefined);
            redirectToLoginPage(undefined, { force: true });
        },
        redirectToLogin({ commit }) {
            if (isAuthRedirectInFlight()) {
                return;
            }
            commit("setChatLaunchNotice", null);
            commit("isAuthenticated", { isAuthenticated: false });
            clearClientSession();
            import("../../helper/sso").then((m) => m.resetSsoConfigCache()).catch(() => undefined);
            if (typeof window !== "undefined" && window.__SOCIAL_IS_AGENCY_SITE) {
                redirectToLoginPage();
                return;
            }
            import("../../helper/sso").then(({ loadSsoConfig, mustUseSsoOnly, redirectToSsoLogin, getCachedSsoConfig }) => {
                const cached = getCachedSsoConfig();
                const done = (cfg) => {
                    if (cfg && mustUseSsoOnly(cfg)) {
                        redirectToSsoLogin(cfg);
                        return;
                    }
                    redirectToLoginPage();
                };
                if (cached) {
                    done(cached);
                    return;
                }
                loadSsoConfig(false).then(done).catch(() => redirectToLoginPage());
            }).catch(() => redirectToLoginPage());
        },
        getXsrfToken(context, payload) {
            AuthService.getXsrfToken().then(res => {
                let XsrfToken = res.config.headers['X-XSRF-TOKEN'];
                axios.defaults.headers.common.X_XSRF_TOKEN = XsrfToken;
            });
        },
        setAuth() {
            AuthService.getXsrfToken().then(res => {
                const XsrfToken = res.config.headers['X-XSRF-TOKEN'];
                console.log(XsrfToken);
                axios.defaults.headers.common.X_XSRF_TOKEN = XsrfToken;
                localStorage.setItem("X_XSRF_TOKEN", XsrfToken);
            });
            // axios.interceptors.request.use(function (config) {
            //     console.log('axios.interceptors');
            //     const access_token = localStorage.getItem("access_token");
            //     const XsrfToken = localStorage.getItem("X_XSRF_TOKEN");
            //
            //     if (access_token) {
            //         config.headers.Authorization = `Bearer ${access_token}`;
            //         config.headers.X_XSRF_TOKEN = XsrfToken;
            //     }
            //
            //     return config;
            // });
        },
        // setAuth(auth) {
        //   // axios.interceptors.request.use(function (config) {
        //   //   if (auth) {
        //   axios.defaults.headers.common['Authorization'] = `Bearer ${auth.access_token}`;
        //   // config.headers.Authorization = `Bearer ${auth.access_token}`;
        //   //   }
        //   //   return config;
        //   // });
        // }
        //
        connectToSocket(token) {
            // ws.on('connect', () => {
            //     console.log('socket connect');
            //     ws.emit('message', JSON.stringify({"action": "login", "token": `${token}`}));
            // });
            //
            // ws.on('connect', () => {
            //     console.log('socket connect');
            //     ws.emit('message_reaction_emoji', JSON.stringify({"action": "login", "token": `${token}`}));
            // });
            //
            // ws.on('connect', () => {
            //     console.log('socket connect');
            //     ws.emit('modify_information_chat', JSON.stringify({"action": "login", "token": `${token}`}));
            // });
        },
        async getSocialSettings({ commit, dispatch }, payload) {
            await SettingService.getSettings().then((res) => {
                const body = res;
                const list = body.data;
                if (!list || !Array.isArray(list))
                    return;
                const setting_tag = list.find((item) => item.name === 'tag_dictionary');
                console.log('selected settings', setting_tag);
                if (!setting_tag?.value)
                    return;
                setting_tag.value = JSON.parse(setting_tag.value).map((item) => '#' + item);
                commit("updateDictionarySetting", setting_tag);
            });
        }
    }
};
